import React, { useContext } from 'react';
import { Button, Icon } from '@sumtotal/react-foundation';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import Config from '../../../config/Config';
import CurrentThemeContext from '../../../contexts/ThemeContext';
import {
  MobileAppHeader,
  MobileAppPageContainer,
  FooterContainer
} from './mobileAppMenuHeaderStyles';
import { Img } from '../../../modules/dashboards/components/templates/templateStyles';
import { ApplicationPaths } from '../../../authentication/AuthorizationConstants';
import useCustomNavigation from '../../hooks/useCustomNavigation';

const MobileAppMenu = () => {
  const navigate = useCustomNavigation();
  const themeContext = useContext(CurrentThemeContext);
  const { t } = useTranslation(['TRANSLATIONS_RCORE_ACTIVITY_QR_CODE_ATTENDANCE']);
  const { logoData, favIconData } = themeContext;
  const [previewLogoUrl] = logoData;
  const [favIconUrl] = favIconData;
  const parsedUrl = queryString.parseUrl(window.location.href);
  const storeUrl = parsedUrl.query?.storeUrl || null;
  const activityId = parsedUrl.query?.activityId || null;
  const actQrCode = parsedUrl.query?.actQrCode || null;
  const deeplinkToActDetails = parsedUrl.query?.deeplinkToActDetails || null;
  const wcEmail = parsedUrl.query?.wcEmail || null;
  const soURL = parsedUrl.query?.soURL || null;
  const urlscheme = parsedUrl.query?.urlscheme || null;
  const deviceType = parsedUrl.query?.deviceType || null;

  let LogoSrc = `${Config.domain}//${Config.logo}`;
  if (previewLogoUrl && previewLogoUrl !== '') {
    LogoSrc = previewLogoUrl;
  }
  let favIconSrc = `${Config.domain}${Config.favicon}`;
  if (favIconUrl && favIconUrl !== '') {
    favIconSrc = favIconUrl;
  }
  const handleLogOut = () => {
    navigate(ApplicationPaths.Logout);
  };

  const navigateToAppStore = () => {
    // For iOS device When the Sumtotal Mobile gets installed, copy the url to clipboard and auto populate the deeplink url and navigate to mark QR Code details page once the app gets installed on the device.
    if (deviceType !== undefined && deviceType !== null && deviceType === 'ios') {
      constructAndCopyToClipBoardQRCodeDeeplink();
    }
    if (storeUrl !== null) {
      window.location.replace(storeUrl);
    }
  };

  const constructAndCopyToClipBoardQRCodeDeeplink = async () => {
    let qrCodeDeepLinkUrl = `${window.location.origin}`;
    if (wcEmail !== null && wcEmail !== '') {
      qrCodeDeepLinkUrl = `${qrCodeDeepLinkUrl}&wcEmail=${wcEmail}`;
    }
    if (soURL !== null && soURL !== '') {
      qrCodeDeepLinkUrl = `${qrCodeDeepLinkUrl}&soURL=${soURL}`;
    }
    if (deeplinkToActDetails !== null && deeplinkToActDetails !== '') {
      qrCodeDeepLinkUrl = `${qrCodeDeepLinkUrl}&deeplinkToActDetails=${deeplinkToActDetails}`;
    }
    if (activityId !== null && activityId !== '') {
      qrCodeDeepLinkUrl = `${qrCodeDeepLinkUrl}&ActivityId=${activityId}`;
    }
    if (actQrCode !== null && actQrCode !== '') {
      qrCodeDeepLinkUrl = `${qrCodeDeepLinkUrl}&ActQRCode=${actQrCode}`;
    }
    if (qrCodeDeepLinkUrl !== null && qrCodeDeepLinkUrl !== '') {
      await navigator.clipboard.writeText(
        `${urlscheme}:${urlscheme}://?esbURL=${qrCodeDeepLinkUrl}`
      );
    }
  };

  return (
    <>
      <MobileAppPageContainer>
        <MobileAppHeader>
          {/* If required we will add new Mobile App header component on react-foundation as part of UI changes for that we had separate story */}
          {LogoSrc !== '' && <Img className="logo-image" src={LogoSrc} />}
          <Button
            variant="text"
            size="small"
            onClick={handleLogOut}
            startIcon={<Icon iconType="MaterialIcon" iconName="ExitToApp" size={1} />}
          >
            {t('RCORE_QR_CODE_ATTENDANCE_LOGOUT')}
          </Button>
        </MobileAppHeader>
        <FooterContainer>
          <div className="left-content">
            {favIconSrc !== '' && <Img className="favlogo" src={favIconSrc} />}
            <p>{t('RCORE_GET_APP')}</p>
          </div>
          <Button variant="primary" className="button" onClick={navigateToAppStore}>
            {t('RCORE_OPEN_APP')}
          </Button>
        </FooterContainer>
      </MobileAppPageContainer>
    </>
  );
};

export default MobileAppMenu;
